const CLIENTS_BASE = '/v1/private/clients/';

export const buildClientFileUrl = (
  cuit: string | undefined,
  fileId: string | undefined
) => CLIENTS_BASE + cuit + '/files/' + encodeURIComponent(fileId ?? '');

export const buildApplicationClientFileUrl = (
  cuit: string | undefined,
  applicationId: string,
  fileId: string | undefined
) =>
  CLIENTS_BASE +
  cuit +
  '/applications/' +
  applicationId +
  '/files/' +
  encodeURIComponent(fileId ?? '');

export const buildApplicationFileUrl = (
  cuit: string,
  applicationId: string,
  fileName: string
) =>
  `${CLIENTS_BASE}${cuit}/applications/${applicationId}/files/${encodeURIComponent(fileName)}`;
